var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.609 10.781a15.5 15.5 0 0 0 6.609 6.609l2.203-2.203c.281-.281.703-.375 1.031-.234 1.125.375 2.344.563 3.563.563a.96.96 0 0 1 .984.984v3.516a.96.96 0 0 1-.984.984C10.64 21 2.999 13.359 2.999 3.984A.96.96 0 0 1 3.983 3h3.516a.96.96 0 0 1 .984.984c0 1.266.188 2.438.563 3.563.094.328.047.75-.234 1.031z"
  })));
};
export default SvgPhone;